import { useTranslation } from "react-i18next";
import ImagesPreview from "./ImagesPreview";
import PollPreview from "./PollPreview";
import DocumentsEndpoints from "@serie3/mymediaplanner/Modules/Documents/endpoints";

const LinkedinPreview = ({ text, postFiles = null, poll, name = null, binaryEndpoint = DocumentsEndpoints.show, post = null }) => {
  const { t } = useTranslation();

  const initials = name
    ? name.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase()
    : "YN";

  return (
    <div style={{
      maxWidth: 555,
      margin: "0 auto",
      background: "#fff",
      borderRadius: 12,
      border: "1px solid #e0e0e0",
      boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      overflow: "hidden",
    }}>

      {/* Length warning */}
      {text && text.length > 3000 && (
        <div style={{ background: "#fff3cd", color: "#856404", fontSize: 12, padding: "8px 16px", borderBottom: "1px solid #ffe69c" }}>
          {t("Backend.Post.Linkedin.LengthWarning")}
        </div>
      )}

      {/* Profile header */}
      <div style={{ display: "flex", alignItems: "flex-start", gap: 10, padding: "14px 16px 10px" }}>
        <div style={{
          width: 48, height: 48, borderRadius: "50%", flexShrink: 0,
          background: "linear-gradient(135deg, #0077b5, #00a0dc)",
          display: "flex", alignItems: "center", justifyContent: "center",
          color: "#fff", fontWeight: 700, fontSize: 16, letterSpacing: "0.5px",
        }}>
          {initials}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div>
              <p style={{ margin: 0, fontWeight: 600, fontSize: 14, color: "#000", lineHeight: 1.3 }}>
                {name ?? "Your Name"}
              </p>
              <p style={{ margin: 0, fontSize: 12, color: "#666", lineHeight: 1.4, marginTop: 1 }}>
                Your headline · <span style={{ color: "#888" }}>1st</span>
              </p>
              <p style={{ margin: 0, fontSize: 11, color: "#888", marginTop: 1 }}>
                Just now · <span style={{ fontSize: 11 }}>🌐</span>
              </p>
            </div>
            <button style={{
              border: "1px solid #0077b5", borderRadius: 16,
              background: "transparent", color: "#0077b5",
              fontSize: 13, fontWeight: 600, padding: "4px 14px", cursor: "pointer",
            }}>
              + Follow
            </button>
          </div>
        </div>
      </div>

      {/* Post text */}
      <div style={{ padding: "0 16px 12px", fontSize: 14, color: "#191919", lineHeight: 1.6, whiteSpace: "pre-line" }}>
        {text || ""}
      </div>

      {/* Media / Poll */}
      {postFiles && postFiles.length > 0 ? (
        <ImagesPreview postFiles={postFiles} binaryEndpoint={binaryEndpoint} post={post} />
      ) : poll ? (
        <div style={{ padding: "0 16px 12px" }}>
          <PollPreview poll={poll} />
        </div>
      ) : null}

      {/* Reaction counts */}
      <div style={{ padding: "6px 16px", borderTop: "1px solid #e9e9e9", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontSize: 12, color: "#666" }}>
          <span style={{ fontSize: 13 }}>👍❤️💡</span> 128
        </span>
        <span style={{ fontSize: 12, color: "#666" }}>24 comments · 8 reposts</span>
      </div>

      {/* Action bar */}
      <div style={{ display: "flex", borderTop: "1px solid #e9e9e9", padding: "2px 0" }}>
        {[
          { icon: "👍", label: "Like" },
          { icon: "💬", label: "Comment" },
          { icon: "🔁", label: "Repost" },
          { icon: "📤", label: "Send" },
        ].map(({ icon, label }) => (
          <button key={label} style={{
            flex: 1, background: "none", border: "none", cursor: "default",
            padding: "10px 4px", display: "flex", flexDirection: "column",
            alignItems: "center", gap: 2, color: "#666",
            fontSize: 12, fontWeight: 600,
          }}>
            <span style={{ fontSize: 16 }}>{icon}</span>
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LinkedinPreview;
